@if (paymentInfo().cardType === 'EC') {
  <span>{{ 'orderConfirmation.eCheckPayment' | cxTranslate }} </span>
} @else {
  <span>{{ paymentInfo().cardType }} </span>
}
<span>{{ InvoiceUtils.getCardNumber(paymentInfo().cardNumber) }}</span>
